/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Client } from './';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { Freelancer } from './';
import {
    FreelancerFromJSON,
    FreelancerFromJSONTyped,
    FreelancerToJSON,
} from './';
import type { QuoteClientTermsResource } from './';
import {
    QuoteClientTermsResourceFromJSON,
    QuoteClientTermsResourceFromJSONTyped,
    QuoteClientTermsResourceToJSON,
} from './';
import type { QuoteProjectTermsResource } from './';
import {
    QuoteProjectTermsResourceFromJSON,
    QuoteProjectTermsResourceFromJSONTyped,
    QuoteProjectTermsResourceToJSON,
} from './';
import type { QuoteResource } from './';
import {
    QuoteResourceFromJSON,
    QuoteResourceFromJSONTyped,
    QuoteResourceToJSON,
} from './';
import type { QuoteStatus } from './';
import {
    QuoteStatusFromJSON,
    QuoteStatusFromJSONTyped,
    QuoteStatusToJSON,
} from './';
import type { QuoteType } from './';
import {
    QuoteTypeFromJSON,
    QuoteTypeFromJSONTyped,
    QuoteTypeToJSON,
} from './';
import type { TimeAndMaterialsQuoteDetailsResource } from './';
import {
    TimeAndMaterialsQuoteDetailsResourceFromJSON,
    TimeAndMaterialsQuoteDetailsResourceFromJSONTyped,
    TimeAndMaterialsQuoteDetailsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeAndMaterialsQuoteResource
 */
export interface TimeAndMaterialsQuoteResource extends QuoteResource {
    /**
     * 
     * @type {TimeAndMaterialsQuoteDetailsResource}
     * @memberof TimeAndMaterialsQuoteResource
     */
    details: TimeAndMaterialsQuoteDetailsResource;
}

/**
 * Check if a given object implements the TimeAndMaterialsQuoteResource interface.
 */
export function instanceOfTimeAndMaterialsQuoteResource(value: object): value is TimeAndMaterialsQuoteResource {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function TimeAndMaterialsQuoteResourceFromJSON(json: any): TimeAndMaterialsQuoteResource {
    return TimeAndMaterialsQuoteResourceFromJSONTyped(json, false);
}

export function TimeAndMaterialsQuoteResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAndMaterialsQuoteResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteResourceFromJSONTyped(json, ignoreDiscriminator),
        'details': TimeAndMaterialsQuoteDetailsResourceFromJSON(json['details']),
    };
}

export function TimeAndMaterialsQuoteResourceToJSON(value?: TimeAndMaterialsQuoteResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteResourceToJSON(value, true),
        'details': TimeAndMaterialsQuoteDetailsResourceToJSON(value['details']),
    };
}

